import { TelecomNumberType } from 'src/types/api'
import { closeWithFallback } from './closeWithFallback'
import {
  monitoredHrefReplace,
  monitoredOpen,
  monitoredReplace,
} from 'src/service/utils/sentry/navigation'

type DeviceType = 'WEB' | 'IOS' | 'AOS'

export const iosUrl =
  'https://apps.apple.com/kr/app/%ED%9C%B4%EB%8C%80%ED%8F%B0%EC%BF%A0%ED%8F%B0%EC%A7%80%EA%B0%91-%EC%83%81%EC%8B%9C%ED%95%A0%EC%9D%B8-%ED%8A%B9%EA%B0%80%EC%BF%A0%ED%8F%B0/id6502936747'
export const aosUrl = 'https://play.google.com/store/apps/details?id=co.kr.datau.saturn_aos&hl=ko'

export const billLetterIosUrl = `sendEventToApp:onClickedOutPage=${iosUrl}`
export const billLetterAosUrl = `sendEventToApp:onClickedOutPage=${aosUrl}`

const SERVICE_HOST = process.env.REACT_APP_SERVICE_HOST
export const serviceWebUrl = `https://${SERVICE_HOST}`

// generateRandomNumber
function grn(): string {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1)
}

// generateRequestID
export function gri(): string {
  return `${grn()}${grn()}-${grn()}-${grn()}-${grn()}-${grn()}${grn()}${grn()}`
}

export function deviceDetection(): DeviceType {
  const userAgent = navigator.userAgent.toLowerCase()
  const isIOS = /iphone|ipad|ipod/.test(userAgent)
  const isAndroid = /android/.test(userAgent)

  if (isIOS) {
    return 'IOS'
  } else if (isAndroid) {
    return 'AOS'
  } else {
    return 'WEB'
  }
}

//open app
export function handleDeviceAppOpen() {
  switch (deviceDetection()) {
    case 'IOS':
      monitoredOpen(iosUrl, 'handleDeviceAppOpen', '_blank')
      // = window.open(iosUrl, '_blank')
      break
    case 'AOS':
    default:
      monitoredOpen(aosUrl, 'handleDeviceAppOpen', '_blank')
      // = window.open(aosUrl, '_blank')
      break
  }
  window.self.close()
}

export function handleMoveToAppStore(options?: { skipCloseFallback?: boolean }) {
  const runCloseFallback = !options?.skipCloseFallback

  switch (deviceDetection()) {
    case 'IOS':
      // = window.location.replace(iosUrl)
      monitoredReplace(iosUrl, 'handleMoveToAppStore')
      if (runCloseFallback) setTimeout(closeWithFallback, 100)
      break
    case 'AOS':
      // = window.location.replace(aosUrl)
      monitoredReplace(aosUrl, 'handleMoveToAppStore')
      if (runCloseFallback) setTimeout(closeWithFallback, 100)
      break
    default:
      // = window.location.replace(aosUrl)
      monitoredReplace(aosUrl, 'handleMoveToAppStore')
      break
  }
}

//billletter open app
export function handleBillLetterAppOpen() {
  switch (deviceDetection()) {
    case 'IOS':
      // = window.location.href = billLetterIosUrl
      monitoredHrefReplace(billLetterIosUrl, 'handleBillLetterAppOpen', {
        skipVerification: true,
      })
      break
    case 'AOS':
    default:
      // = window.location.href = billLetterAosUrl
      monitoredHrefReplace(billLetterAosUrl, 'handleBillLetterAppOpen', {
        skipVerification: true,
      })
      break
  }
}

//open service
export function handleMoveToService(pCode: string) {
  // = window.open()
  monitoredOpen(`${serviceWebUrl}/web/splash?pCode=${pCode}`, 'handleMoveToService', '_blank')
}

export function handleMoveToSvcLoginPage(
  pCode: string,
  telecom: TelecomNumberType,
  pNumber: string,
) {
  // = window.location.replace()
  monitoredReplace(
    `${serviceWebUrl}/web/join/link/${telecom}?pCode=${pCode}&pNumber=${pNumber}`,
    'handleMoveToSvcLoginPage',
  )
}
